import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { PhoneFrame } from "@/components/PhoneFrame";
import { listenForAppLinks } from "@/lib/native";

import Splash from "@/pages/Splash";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Products from "@/pages/Products";
import ProductDetails from "@/pages/ProductDetails";
import Recipes from "@/pages/Recipes";
import RecipeDetails from "@/pages/RecipeDetails";
import HealthGuide from "@/pages/HealthGuide";
import HealthGuideDetails from "@/pages/HealthGuideDetails";
import Exercise from "@/pages/Exercise";
import ExerciseDetails from "@/pages/ExerciseDetails";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  const navigate = useNavigate();
  // Native shell only: route incoming Android App Links (OAuth return) through the in-app router.
  useEffect(() => listenForAppLinks((path) => navigate(path, { replace: true })), [navigate]);
  // Process Emergent OAuth callback before anything else (read hash reactively).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <PhoneFrame>
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/home" element={<Home />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/recipes/:id" element={<RecipeDetails />} />
        <Route path="/guide" element={<HealthGuide />} />
        <Route path="/guide/:id" element={<HealthGuideDetails />} />
        <Route path="/exercise" element={<Exercise />} />
        <Route path="/exercise/:id" element={<ExerciseDetails />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </PhoneFrame>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
